/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPayorTypeSummary } from './HchbPayorTypeSummary';
import {
    HchbPayorTypeSummaryFromJSON,
    HchbPayorTypeSummaryFromJSONTyped,
    HchbPayorTypeSummaryToJSON,
    HchbPayorTypeSummaryToJSONTyped,
} from './HchbPayorTypeSummary';

/**
 * 
 * @export
 * @interface HchbPayorTypePage
 */
export interface HchbPayorTypePage {
    /**
     * 
     */
    data: Array<HchbPayorTypeSummary>;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the HchbPayorTypePage interface.
 */
export function instanceOfHchbPayorTypePage(value: object): value is HchbPayorTypePage {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function HchbPayorTypePageFromJSON(json: any): HchbPayorTypePage {
    return HchbPayorTypePageFromJSONTyped(json, false);
}

export function HchbPayorTypePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorTypePage {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbPayorTypeSummaryFromJSON)),
        'page': json['page'],
        'limit': json['limit'],
        'total': json['total'],
        'has_next': json['has_next'],
    };
}

export function HchbPayorTypePageToJSON(json: any): HchbPayorTypePage {
    return HchbPayorTypePageToJSONTyped(json, false);
}

export function HchbPayorTypePageToJSONTyped(value?: HchbPayorTypePage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(HchbPayorTypeSummaryToJSON)),
        'page': value['page'],
        'limit': value['limit'],
        'total': value['total'],
        'has_next': value['has_next'],
    };
}

